import { nodeListToArray } from "../helpers/nodeListToArray";

const loadAllBtn = document.querySelector('.adage-provider-aside-btn-js');
const secondaryLocations = document.querySelector('.adage-locations-secondary-js');

if (loadAllBtn) {
    loadAllBtn.addEventListener('click', function () {
        if (secondaryLocations.classList.contains('adage-provider-aside-locations-secondary-open')) {
            secondaryLocations.classList.remove('adage-provider-aside-locations-secondary-open');
            loadAllBtn.textContent = loadAllBtn.textContent.replace("Show Less", "Load All").replace("-", "+");
        }
        else {
            secondaryLocations.classList.add('adage-provider-aside-locations-secondary-open');
            loadAllBtn.textContent = loadAllBtn.textContent.replace("Load All", "Show Less").replace("+", "-");
        }
    })
}

// Hide UL list styles if UL only has one list item
// Only targeting UL lists in wysiwygs

let providerContent = document.querySelector('.adage-provider-accordion-js');

if (providerContent) {
    let contentAreas = nodeListToArray(providerContent.querySelectorAll('.adage-provider-accordion-content-details'));

    if (contentAreas) {
        contentAreas.forEach(contentArea => {
            let unorderedLists = nodeListToArray(contentArea.querySelectorAll('ul'));

            if (unorderedLists) {
                unorderedLists.forEach(unorderedList => {
                    let listItems = nodeListToArray(unorderedList.querySelectorAll('li'));

                    if (listItems && !(listItems.length > 1)) {
                        unorderedList.classList.add('unstyled-list');
                    }
                })
            }
        })
    }
}